<template>
  <div class="scroll-vertical">
    <detail-item
      name="Event Timestamp"
      imgName="circle">
      {{ event.timestamp | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="Product Name"
      imgName="circle">
      {{ event.device.productName }}
    </detail-item>
    <detail-item
      name="Vendor Name"
      imgName="circle">
      {{ event.device.vendorName }}
    </detail-item>
    <detail-item
      name="Serial"
      imgName="circle">
      {{ event.device.serialNumber }}
    </detail-item>
    <detail-item
      name="Removable"
      imgName="circle">
      {{ event.device.removable }}
    </detail-item>
    <detail-item
      name="Writable"
      imgName="circle">
      {{ event.device.writable }}
    </detail-item>
    <detail-item
      name="Class"
      imgName="circle">
      {{ event.device.deviceClass }} / {{ event.device.deviceSubClass }}
    </detail-item>
  </div>
</template>

<script>
import gmt from '@/mixins/gmt';
import events from '@/mixins/events';
import DetailItem from '@/components/DetailItem.vue';

export default {
  name: 'GPUSBEvent',
  mixins: [events, gmt],
  components: { DetailItem },
  props: {
    event: {
      type: Object,
      required: true,
    },
    related: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      def: this.$typeDefs.events.GPUSBEvent,
    };
  },
};
</script>
